import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import About from "../components/About";
import Projects from "../components/Projects";
import Pricing from "../components/Pricing";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import SEOHead from "../components/SEOHead";

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead />
      <Header />
      <Hero />
      <About />
      
        {/* Services Section */}
        <section id="services" className="py-12 relative">
          {/* Image de fond (différente de About, teintes bleutées) */}
          <div
            className="absolute inset-0 bg-cover bg-center bg-no-repeat"
            style={{
              backgroundImage: "url('https://images.unsplash.com/photo-1501594907352-04cda38ebc29?auto=format&fit=crop&w=2070&q=80')"
            }}
          ></div>
          {/* Overlay semi-transparent */}
            <div className="absolute inset-0 bg-white/90"></div>
          {/* Contenu */}
          <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl font-caveat">Mes Services</h2>
              <p className="mt-4 max-w-3xl mx-auto text-lg sm:text-xl text-gray-700">
                Un accompagnement complet et personnalisé pour tous vos projets de construction, rénovation et aménagement.
              </p>
            </div>

            <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {/* Lecture de devis */}
              <div className="bg-blue-50 rounded-lg p-5 md:p-6 border border-blue-100 shadow-sm hover:shadow-md transition">
                <div className="flex items-start">
                  <svg className="w-7 h-7 text-blue-900 mr-3 mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  <div>
                    <h3 className="text-base font-semibold text-gray-900 mb-2">Lecture de devis</h3>
                    <p className="text-sm text-gray-700 leading-relaxed">
                      Analyse détaillée de vos devis pour détecter incohérences, postes oubliés et optimiser les coûts avant engagement.
                    </p>
                  </div>
                </div>
              </div>

              {/* Conseil chantier */}
              <div className="bg-blue-50 rounded-lg p-5 md:p-6 border border-blue-100 shadow-sm hover:shadow-md transition">
                <div className="flex items-start">
                  <svg className="w-7 h-7 text-blue-900 mr-3 mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                  </svg>
                  <div>
                    <h3 className="text-base font-semibold text-gray-900 mb-2">Conseil chantier</h3>
                    <p className="text-sm text-gray-700 leading-relaxed">
                      Accompagnement technique pour planifier, organiser et sécuriser chaque étape de votre chantier.
                    </p>
                  </div>
                </div>
              </div>

              {/* Étude de faisabilité */}
              <div className="bg-blue-50 rounded-lg p-5 md:p-6 border border-blue-100 shadow-sm hover:shadow-md transition">
                <div className="flex items-start">
                  <svg className="w-7 h-7 text-blue-900 mr-3 mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                  </svg>
                  <div>
                    <h3 className="text-base font-semibold text-gray-900 mb-2">Étude de faisabilité</h3>
                    <p className="text-sm text-gray-700 leading-relaxed">
                      Validation technique, réglementaire et budgétaire avant lancement de votre projet.
                    </p>
                  </div>
                </div>
              </div>

              {/* Suivi de chantier */}
              <div className="bg-blue-50 rounded-lg p-5 md:p-6 border border-blue-100 shadow-sm hover:shadow-md transition">
                <div className="flex items-start">
                  <svg className="w-7 h-7 text-blue-900 mr-3 mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
                  </svg>
                  <div>
                    <h3 className="text-base font-semibold text-gray-900 mb-2">Suivi de chantier</h3>
                    <p className="text-sm text-gray-700 leading-relaxed">
                      Contrôles réguliers, compte-rendus et ajustements pour respecter délais et qualité.
                    </p>
                  </div>
                </div>
              </div>

              {/* Conseil travaux */}
              <div className="bg-blue-50 rounded-lg p-5 md:p-6 border border-blue-100 shadow-sm hover:shadow-md transition">
                <div className="flex items-start">
                  <svg className="w-7 h-7 text-blue-900 mr-3 mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <div>
                    <h3 className="text-base font-semibold text-gray-900 mb-2">Conseil travaux</h3>
                    <p className="text-sm text-gray-700 leading-relaxed">
                      Accompagnement personnalisé de l'idée à la réalisation pour sécuriser vos décisions.
                    </p>
                  </div>
                </div>
              </div>

              {/* Conseil matériaux */}
              <div className="bg-blue-50 rounded-lg p-5 md:p-6 border border-blue-100 shadow-sm hover:shadow-md transition">
                <div className="flex items-start">
                  <svg className="w-7 h-7 text-blue-900 mr-3 mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
                  </svg>
                  <div>
                    <h3 className="text-base font-semibold text-gray-900 mb-2">Conseil matériaux</h3>
                    <p className="text-sm text-gray-700 leading-relaxed">
                      Sélection des matériaux (durabilité, performance, coût) pour un résultat pérenne et optimisé.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      
  <Pricing />
  <Projects />
        <Contact />
        <Footer />
      </div>
    );
};

export default Home;